import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import Datetime from 'components/DataTypes/Datetime';

const useStyles = makeStyles(theme => ({
  field: {
    marginBottom: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
  },
  json: {
    margin: 0,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    fontFamily: 'monospace',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowX: 'auto',
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

const pretty = value => {
  if (value === null || value === undefined) return '—';
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
};

const AnalyticsDetailsDialog = props => {
  const { item, open, onClose } = props;
  const classes = useStyles();

  if (!item) return null;

  const field = (label, value) => (
    <Grid item xs={12} sm={6} className={classes.field}>
      <Typography variant="caption" className={classes.label}>{label}</Typography>
      <Typography variant="body2">{value || '—'}</Typography>
    </Grid>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Analytics event</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          {field('Type', item.type)}
          {field('Key', item.key)}
          <Grid item xs={12} sm={6} className={classes.field}>
            <Typography variant="caption" className={classes.label}>Generated at</Typography>
            <Datetime value={item.generatedAt} component="div" />
          </Grid>
          {field('Event id', item.id)}
          {field('Account email', item.accountEmail)}
          {field('Profile email', item.profileEmail)}
          {field('Account UUID', item.accountUuid)}
          {field('Application', item.applicationName
            ? `${item.applicationName}${item.applicationVersion ? ` ${item.applicationVersion}` : ''}`
            : null)}
          {field('Session id', item.sessionId)}
          {field('User agent', item.userAgent)}
          {field('GUI active', item.isGuiActive === null || item.isGuiActive === undefined
            ? null : (item.isGuiActive ? 'Yes' : 'No'))}
          {field('Success', item.success === null || item.success === undefined
            ? null : (item.success ? 'Yes' : 'No'))}
          {field('Elapsed (ms)', item.elapsedMs === null || item.elapsedMs === undefined
            ? null : String(item.elapsedMs))}
        </Grid>

        <Divider className={classes.section} />
        <Typography variant="subtitle2" gutterBottom>Payload</Typography>
        <pre className={classes.json}>{pretty(item.payload)}</pre>

        <Typography variant="subtitle2" gutterBottom className={classes.section}>Metadata</Typography>
        <pre className={classes.json}>{pretty(item.metadata)}</pre>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

AnalyticsDetailsDialog.propTypes = {
  item: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AnalyticsDetailsDialog;